import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function MatrimonialDisputes() {

  useEffect(() => {
    document.title = "Matrimonial Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
     <Navbar />
    <div className="law">
     
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="./matrimonial-law.jpg" 
              alt="Matrimonial Disputes" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
            At Legal Trails, we are dedicated to providing compassionate support and effective legal solutions for individuals facing domestic violence, ensuring clients navigate their options with care and sensitivity. We prioritize resolving family matters with minimal conflict and stress, offering expert legal services in key areas of family law. Our services include assistance with mutual and contested divorce, encompassing settlement negotiations, alimony, property division, child custody, and strategic court representation. We guide clients through custody arrangements, visitation rights, and modifications to custody orders. For maintenance cases, we offer assistance with filing for spousal and child support, representation in hearings, and enforcement of maintenance orders. In domestic violence cases, we provide support for filing complaints under the Protection of Women from Domestic Violence Act, obtaining protection orders, accessing counseling resources, and seeking compensation and maintenance. Our team ensures that victims’ rights are upheld throughout court proceedings, offering comprehensive legal and emotional support during challenging times.
              </p>

            <div className="button-container">
              <Link to="/contact">
                <button className="contact-button">Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default MatrimonialDisputes;
